export class CustomFileModel {
    Name: string; // Name with extension
    Content: string; // String of content (N.B. no base64)
    constructor(fileNameWithExtewnsion: string, fileContent: string) {
        this.Name = fileNameWithExtewnsion;
        this.Content = fileContent;
    }
}
